module.exports = __webpack_public_path__ + "img/play.88c383d6.svg";